module.exports = __webpack_public_path__ + "static/media/ios-moon.9942dfeb.svg";